import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";
import ComparisonCardsDetailed from "./ComparisonCardsDetailed";

export type FeaturesType = {
  heading?: string;
  highlight?: string;
  subheading: string;
};

export type ComparisonFeaturesWithCtaPropsType = {
  langFile: string;
  data: {
    type: string;
    competitorLogo: string;
    features: {
      header: string;
      emoji: string;
      highlights: {
        icon: string;
        text: string;
        customWidth?: number;
      }[];
      graphyHeader: string;
      graphyFeatures: FeaturesType[];
      competitorHeader: string;
      competitorFeatures: FeaturesType[];
    }[];
    ctas: CtaType[];
    discountInfo: string;
  };
};

const ComparisonFeaturesWithCta = ({
  data,
}: ComparisonFeaturesWithCtaPropsType) => {
  return (
    <div className="py-16 md:py-10">
      <div className="container flex flex-col items-center gap-10">
        <ComparisonCardsDetailed
          competitorHeader={data.features[0].competitorHeader}
          competitorFeatures={data.features[0].competitorFeatures}
          competitorLogo={data?.competitorLogo}
          graphyHeader={data.features[0].graphyHeader}
          graphyFeatures={data.features[0].graphyFeatures}
          isRight={false}
          emoji={data.features[0].emoji}
        />
        <div className="mt-2 flex flex-col items-center">
          <CtaButtonGroup
            ctas={data?.ctas}
            gap="gap-4"
            fullWidthOnMobile={false}
          />
          <div className="mt-2 flex items-center gap-2">
            <img
              src="/images/icons/percentage-pink.svg"
              alt="company logo"
              className="h-4 w-4"
            />
            <p className="text-body-12 font-normal text-grey-4">
              {data?.discountInfo}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonFeaturesWithCta;
